import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const SettingsContext = createContext({});

const DEFAULTS = {
  company_name: 'Apex Towing Solutions',
  company_phone: '0400 000 000',
  company_email: 'info@apextowing.com.au',
  company_address: 'Brisbane, QLD',
  company_abn: '',
  company_website: 'www.apextowing.com.au',
  logo_url: '',
  facebook_url: '',
  tiktok_url: '',
  instagram_url: '',
  whatsapp: '',
  bsb: '',
  account_number: '',
  account_name: '',
  payid: '',
  payment_terms: 'Payment due within 14 days',
  invoice_notes: 'Thank you for choosing Apex Towing Solutions!',
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/api/settings/general');
      if (res.data) setSettings({ ...DEFAULTS, ...res.data });
    } catch (e) {
      console.warn('Could not load settings, using defaults');
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Convenience: formatted tel: link from any phone string
  const telHref = (ph) => {
    const digits = (ph || settings.company_phone).replace(/\D/g, '');
    if (digits.startsWith('61')) return `tel:+${digits}`;
    return `tel:+61${digits.slice(1)}`;
  };

  const waHref = (msg = '') => {
    const num = (settings.whatsapp || settings.company_phone).replace(/\D/g, '');
    const n = num.startsWith('61') ? num : `61${num.slice(1)}`;
    return `https://wa.me/${n}${msg ? `?text=${encodeURIComponent(msg)}` : ''}`;
  };

  return (
    <SettingsContext.Provider value={{ settings, refresh, loaded, telHref, waHref }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);